import React from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText, Divider, Typography } from '@mui/material';
import TableChartIcon from '@mui/icons-material/TableChart';
import DescriptionIcon from '@mui/icons-material/Description';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PrintIcon from '@mui/icons-material/Print';
import Title from '../../../components/Title';

const ExportContainer = (props) => {
    let { exportAnchorEl, handleExportClose, handlePrint, handleExcelExport, handleCsvExport, handlePdfExport } = props;
    const openExportMenu = Boolean(exportAnchorEl);

    const handleExportFormat = (format) => {
        switch (format) {
            case 'excel':
                handleExcelExport();
                break;
            case 'csv':
                handleCsvExport();
                break;
            case 'pdf':
                handlePdfExport();
                break;
            case 'print':
              handlePrint();
                break;
            default:
                break;
        } 
        handleExportClose(); // Ferme le menu après le choix
    }

    return (
        <>
        {/* Menu d'exportation */}
              <Menu
                anchorEl={exportAnchorEl}
                open={openExportMenu}
                onClose={handleExportClose}
                PaperProps={{
                  elevation: 3,
                  sx: { minWidth: 200, mt: 1 }
                }}
              >
                <MenuItem disabled sx={{ opacity: 0.7 }}>
                  <Typography variant="caption" color="text.secondary">
                    Choisir un format
                  </Typography>
                </MenuItem>
                <Divider />
                <MenuItem onClick={() => handleExportFormat('excel')}>
                  <ListItemIcon>
                    <TableChartIcon fontSize="small" color="success" />
                  </ListItemIcon>
                  <ListItemText primary="📊 Excel" secondary=".xlsx" />
                </MenuItem>
                <MenuItem onClick={() => handleExportFormat('csv')}>
                  <ListItemIcon>
                    <DescriptionIcon fontSize="small" color="primary" />
                  </ListItemIcon>
                  <ListItemText primary="📄 CSV" secondary=".csv" />
                </MenuItem>
                <MenuItem onClick={() => handleExportFormat('pdf')}>
                  <ListItemIcon>
                    <PictureAsPdfIcon fontSize="small" color="error" />
                  </ListItemIcon>
                  <ListItemText primary="🖨️ PDF" secondary=".pdf" />
                </MenuItem>
                <Divider />
                <MenuItem onClick={() => handleExportFormat('print')}>
                  <ListItemIcon>
                    <PrintIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Imprimer" />
                </MenuItem>
              </Menu>
        </>
    );
};

export default ExportContainer;